module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ribbon_bg.3e496bc7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Footer/images/ribbon_bg.png
// module id = 3456
// module chunks = 11